import { API } from 'aws-amplify';
import { TUTORING_V2_URL_APPEND } from 'constants';

export const getV2Session = async (sessionId) => {
  const session = await API.get(
    'delta-api',
    `${TUTORING_V2_URL_APPEND}/sessions/${sessionId}`,
  );
  return session;
};
